// src/components/dashboard/PageCard.jsx
import React from 'react';
import { Edit3, Copy, Check, Trash2, BarChart3 } from 'lucide-react';

export default function PageCard({ page, onEdit, onCopy, onDelete, copiedUrl }) {
  const displayComponents = page.components.slice(0, 2);
  const moreCount = page.components.length - 2;

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
      <div className="p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2 truncate">
          {page.title}
        </h3>
        <p className="text-sm text-gray-500 mb-4">
          创建于 {page.createdAt} • 更新于 {page.updatedAt}
        </p>
        <div className="flex items-center space-x-2 mb-3">
          <BarChart3 className="w-4 h-4 text-blue-600" />
          <span className="text-sm text-gray-600">访问量: {page.viewCount}</span>
        </div>
        <div className="space-y-3 mb-4">
          {displayComponents.map((comp, idx) => {
            let text = '';
            if (comp.type === 'button') {
              text = `按钮: ${comp.content.text} (${comp.content.action === 'copy' ? '复制' : comp.content.action === 'link' ? '跳转' : '无操作'})`;
            } else if (comp.type === 'image') {
              text = '图片: [图片]';
            } else {
              text = `${comp.type === 'title' ? '标题' : '文本'}: ${typeof comp.content?.text === 'string' ? comp.content.text.substring(0, 30) + '...' : ''}`;
            }
            return (
              <div key={idx} className="text-sm text-gray-600 truncate">
                {text}
              </div>
            );
          })}
          {moreCount > 0 && (
            <p className="text-sm text-gray-400">+{moreCount} 个更多组件</p>
          )}
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => onEdit(page)}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-3 rounded-lg text-sm font-medium transition-colors flex items-center justify-center space-x-1"
          >
            <Edit3 className="w-4 h-4" />
            <span>编辑</span>
          </button>
          <button
            onClick={() => onCopy(page)}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-lg text-sm font-medium transition-colors flex items-center justify-center space-x-1"
          >
            {copiedUrl === page.id ? (
              <>
                <Check className="w-4 h-4" />
                <span>已复制</span>
              </>
            ) : (
              <>
                <Copy className="w-4 h-4" />
                <span>复制链接</span>
              </>
            )}
          </button>
          <button
            onClick={() => onDelete(page.id)}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 px-3 rounded-lg text-sm font-medium transition-colors flex items-center justify-center"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}